import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  textStyle: {
    fontWeight: 'bold',
    fontSize: 20,
    color: '#161D4B',
  },
  text: {
    textAlign: 'justify',
    fontSize: 15,
    marginTop: 0,
  },
  textMarginTop10: {
    textAlign: 'justify',
    fontSize: 15,
    marginTop: 10,
  },
}));
